import * as httpCall from "../../../Utils/apis/apis";
import defaultMinervaTheme from "../../Themes/defaultMinervaTheme";

export async function getRecordByProperty(apiPayload) {
  const res = await httpCall.httpPost(
    `${process.env.API_URL}/CRMData/getRecordByProperty`,
    apiPayload
  );
  let contact_crm = "";
  if (res && res.length > 0 && res[0] && res[0].id) {
    contact_crm = res[0];
  }
  if (contact_crm) {
    localStorage.setItem("contact_crm", JSON.stringify(contact_crm));
  } else {
    localStorage.setItem("contact_crm", "{}");
  }
}

export async function getGlobalSearchPermission(user) {
  let globalSearchPermissionRes = await httpCall.httpGet(
    "/CRMData/globalSearchPermission"
  );
  if (user) {
    const response = globalSearchPermissionRes;
    return response;
  } else {
    return false;
  }
}
export async function getColourScheme() {
  let apiUrl = "/ColourScheme";
  let colourSchemeResult = await httpCall.httpGet(apiUrl);
  if ("message" in colourSchemeResult) {
    const defaultSerializedTheme = JSON.stringify(defaultMinervaTheme);
    localStorage.setItem("minervaTheme", defaultSerializedTheme);
  } else {
    const serializedTheme = JSON.stringify(colourSchemeResult);
    localStorage.setItem("minervaTheme", serializedTheme);
  }
}
export async function validSubdomainUser() {
  let apiUrl = `/common/validsubdomainuser`;
  const validSubdomainUserResponse = await httpCall.httpGet(apiUrl);
  return validSubdomainUserResponse;
}

export async function getDefaultRedirectURLForUser() {
  let apiUrl = "/common/getDefaultRedirectURLForUser";
  let redirectUrl = await httpCall.httpGet(apiUrl);
  return redirectUrl || "/dashboard";
}

export async function getAllUsers() {
  const url =
    "/SQLQuery/getDataFromMultipleSPs?chartSPs=false";
  const data = [
    { id: "Contacts", spName: "DF.usp_GetAllContacts", parameters: {} },
  ];
  return await httpCall.httpPost(url, data);
}

export async function getUserImages(emails) {
  const url = `${process.env.BULK_DOCUMENT_HELPER}`;
  const data = [{ items: emails, type: "image" }];
  const config = {
    headers: {
      "file-operation": "blob-items-link",
      subdomain: "htbdfdev",
      "x-functions-key":
        "jnILRgND4KybI9PNjAmswmlThOet2lykYg-vL_N3miOBAzFuCFHgXw==",
    },
  };
  return await httpCall.httpPost(url, data, config);
}

export async function updateSingleUserImage(
  email,
  updateSingleUserAction,
  dispatch
) {
  try {
    const profileImageKey = `profile_${email}`;
    const imagesRes = await getUserImages([profileImageKey]);
    const images = imagesRes && imagesRes.image ? imagesRes.image : [];
    const userImage = images.find((img) => img.file === profileImageKey);

    dispatch(
      updateSingleUserAction({
        email: email,
        image: userImage ? userImage.link : null,
      })
    );
  } catch (error) {
    console.error("Error updating single user image:", error);
  }
}
